module.exports = __webpack_public_path__ + "img/a_store.545e5d81.svg";